import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {CardModel} from '../../../models/api/cardModel';

/*
 * Props.
 */

interface ContactCardFooterOpenDetailsProps {
  onOpenContactDetails: () => void;
  card?: CardModel;
}

/*
 * Style.
 */

const StyledOpenDetailsWrapperDiv = styled.div`
  display: flex;
`;

/*
 * Component.
 */

export const ContactCardFooterOpenDetails: FC<ContactCardFooterOpenDetailsProps> = ({
  onOpenContactDetails,
  card,
}) => (
  <StyledOpenDetailsWrapperDiv>
    <Button variant={ButtonVariantsEnum.SECONDARY} onClick={onOpenContactDetails} isDisabled={card?.isDenied}>
      <Trans id="contact-card-open-details-button">Open details</Trans>
    </Button>
  </StyledOpenDetailsWrapperDiv>
);
